/**
 * Locale: Español · clave default de la plataforma.
 *
 * Cualquier string sin traducción todavía cae aquí (fallbackLng: "es").
 */
const es = {
  common: {
    save: "Guardar",
    saveChanges: "Guardar cambios",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    create: "Crear",
    confirm: "Confirmar",
    close: "Cerrar",
    loading: "Cargando…",
    saving: "Guardando…",
    search: "Buscar…",
    yes: "Sí",
    no: "No",
    reload: "Recargar",
    refresh: "Actualizar",
    new: "Nuevo",
    actions: "Acciones",
    status: "Estado",
    active: "Activo",
    inactive: "Inactivo",
    name: "Nombre",
    email: "Email",
    password: "Contraseña",
    role: "Rol",
    logout: "Cerrar sesión",
    settings: "Ajustes",
    notifications: "Notificaciones",
    backToDashboard: "Volver al panel",
    error: "Error",
    success: "Hecho",
    required: "Obligatorio",
    optional: "Opcional",
  },

  language: {
    label: "Idioma",
    es: "Español",
    en: "English",
    toggleTooltip: "Cambiar idioma",
  },

  login: {
    welcome: "Bienvenido",
    subtitle: "Inicia sesión en tu cuenta",
    tabLogin: "Iniciar sesión",
    tabSignup: "Solicitar acceso",
    email: "Email",
    emailPlaceholder: "tu@valorizasm.com",
    password: "Contraseña",
    passwordPlaceholder: "••••••••",
    submit: "Iniciar sesión",
    submitting: "Iniciando…",
    invalidCredentials: "Credenciales inválidas",
    platformName: "Plataformas Corporativas",
    platformTagline: "El cockpit comercial de Valoriza: detección de licitaciones, pipeline, ofertas y comité en un único lugar",
    forgotPassword: "¿Olvidaste tu contraseña?",
    signupName: "Nombre completo",
    signupSubmit: "Solicitar acceso",
    signupSuccess: "Solicitud enviada. Recibirás un email cuando un administrador la apruebe.",
  },

  forcePasswordChange: {
    title: "Cambio de contraseña obligatorio",
    helloUser: "Hola {{name}}. Por seguridad debes establecer tu contraseña personal.",
    currentLabel: "Contraseña actual (provisional)",
    currentPlaceholder: "Contraseña provisional recibida",
    newLabel: "Nueva contraseña",
    newPlaceholder: "Elige una contraseña segura",
    repeatLabel: "Repetir nueva contraseña",
    repeatPlaceholder: "Confirma la contraseña",
    logout: "Cerrar sesión",
    submit: "Establecer contraseña",
    submitting: "Guardando…",
    mismatch: "Las contraseñas no coinciden",
    success: "Contraseña actualizada. Bienvenido/a a la plataforma.",
    rule: {
      minLen: "Mínimo 8 caracteres",
      upper: "Al menos una mayúscula",
      digit: "Al menos un número",
      match: "Las contraseñas coinciden",
    },
  },

  layout: {
    appName: "Valoriza",
    appTagline: "Plataformas Corporativas",
    searchPlaceholder: "Buscar…",
    administrator: "Administrador",
    // Secciones del sidebar
    sectionManagement: "Gestión",
    sectionCommercial: "Comercial",
    sectionOperations: "Operaciones",
    sectionAnalytics: "Analítica",
    // Iter311 · G02 — "5 espacios" del informe de mejoras
    sectionExecution: "Contratos y ejecución",
    sectionDirection: "Dirección",
    sectionAdmin: "Administración",
    // Módulos
    dashboard: "Dashboard",
    miTrabajo: "Mi trabajo",
    projects: "Proyectos",
    backlog: "Backlog",
    sprints: "Sprints",
    checklists: "Checklists",
    offers: "Ofertas TIC",
    ofertasComercial: "Licitaciones",
    tenderIntelligence: "Tender Intelligence",
    mercadoSectorial: "Mercado Sectorial",
    horas: "Gestión de Horas",
    integrationIt: "Integración IT",
    tender360: "US_BID360",
    licitaciones: "Licitaciones SU (legacy)",
    oraZaragoza: "ORA Zaragoza",
    budget: "Presupuesto",
    resources: "Recursos",
    assignments: "Asignaciones",
    devops: "Azure DevOps",
    incidenciasCalidad: "Incidencias de Calidad",
    manuals: "Manuales",
    reports: "Informes",
    executive: "Mando Ejecutivo",
    committee: "Comité",
    weeklySummary: "Resumen Semanal",
    resourceReport: "Informe de Recursos",
    aiHistory: "Historial Pando",
    adjudicaciones: "Adjudicaciones",
    catalogoServicios: "Catálogo de Servicios",
    itPeticiones: "Peticiones IT",
    demanda: "Demanda",
    innovacion: "Innovación",
    pocAi: "PoCs Pando",
    appCatalog: "Catálogo Apps",
    admin: "Administración",
    auditLog: "Audit Log",
    sectionPlatform: "Plataforma",
    sectionKnowledge: "Conocimiento e innovación",
    sectionFavorites: "Favoritos",
    arrive: "Checklists ARRIVE",
  },

  cmdk: {
    placeholder: "Buscar módulos, proyectos, licitaciones…",
    empty: "Sin resultados",
    searching: "Buscando en la plataforma…",
    navigation: "Navegación",
    recents: "Recientes",
    actions: "Acciones",
    darkMode: "Activar modo oscuro",
    lightMode: "Activar modo claro",
    logout: "Cerrar sesión",
    projects: "Proyectos",
    licitaciones: "Licitaciones",
    offers: "Ofertas TIC",
    vsm: "Contratación VSM",
    checklists: "Checklists",
    horas: "Proyectos · Horas",
  },

  delegado: {
    headerLabel: "Valoriza · Delegado Regional",
    reload: "Actualizar",
    logout: "Salir",
    kpi: {
      activeOpps: "Oportunidades activas",
      activeOppsHint: "Score Pando ≥ {{min}}",
      urgent: "Urgentes",
      urgentHint: "Score ≥ 90",
      next7d: "Próximos 7 días",
      next7dHint: "Plazo de presentación cercano",
    },
    filter: {
      label: "Filtro:",
      new: "Nuevas (sin revisar)",
      reviewed: "Revisadas",
      discarded: "Descartadas",
      all: "Todas",
    },
    empty: {
      title: "Sin oportunidades en este filtro",
      hint: "Te avisaremos por email en cuanto entren nuevas en tu zona",
    },
    badge: {
      new: "Nueva",
      reviewed: "Revisada",
      discarded: "Descartada",
    },
    card: {
      score: "Score",
      pub: "Pub:",
      noDeadline: "Sin plazo",
      daysLeft: "{{n}} días",
      daysAgo: "Vencido ({{n}}d)",
      pliegoOriginal: "Pliego original ({{src}})",
      review: "Revisar / Comentar",
      editReview: "Editar revisión",
      organismFallback: "Organismo sin especificar",
    },
    modal: {
      title: "Revisar oportunidad",
      estado: "Estado",
      reviewedBtn: "✓ Revisada",
      discardedBtn: "✕ Descartada",
      newBtn: "↺ Nueva",
      comentario: "Comentario interno",
      comentarioPlaceholder: "Notas para tu seguimiento personal (ej. contacto en el ayuntamiento, riesgos detectados…)",
      saveSuccess: "Marcada como {{estado}}",
    },
    toast: {
      loadError: "Error cargando datos",
      saveError: "Error guardando",
    },
    loadingPanel: "Cargando tu panel…",
  },

  greeting: {
    morning: "Buenos días",
    afternoon: "Buenas tardes",
    evening: "Buenas noches",
  },

  dashboard: {
    quickActions: "Accesos rápidos",
    pendingApproval: "Pendiente Aprobación",
    pendingApprovalSub: "Ofertas en tu bandeja",
    budgetExecuted: "Presupuesto Ejecutado",
    approvedOffers: "Ofertas Aprobadas",
    approvedOffersSub: "este año",
    weightedPipeline: "Pipeline Ponderado",
    activeFiles: "{{n}} expedientes activos",
    pendingOffersTitle: "Ofertas pendientes de tu aprobación",
    noDate: "Sin fecha",
    activeFilesKpi: "Expedientes activos",
    inPipeline: "en pipeline",
    won: "Ganadas",
    wonSub: "licitaciones adjudicadas",
    ongoingOffers: "Ofertas en curso",
    ongoingOffersSub: "pendientes validación",
    tcatApps: "Apps TIC disponibles",
    tcatAppsSub: "en catálogo",
    pipelineTitle: "Pipeline de Licitaciones",
    pendingTicTitle: "Pendiente Validación TIC",
    pendingTicSub: "requieren tu revisión",
    pendingCfoTitle: "Pendiente CFO",
    pendingCfoSub: "en espera de aprobación CFO",
    activeProjects: "Proyectos Activos",
    activeProjectsSub: "{{n}} totales",
    tcatCatalog: "Apps en Catálogo",
    tcatCatalogSub: "catálogo TIC actualizado",
    ticValidationQueue: "Cola de validación TIC",
    roles: {
      cfo: "Director Financiero · Valoriza Plataformas Corporativas",
      offerManager: "Técnico de Ofertas · Valoriza Plataformas Corporativas",
      itValidator: "Validación TIC · Valoriza Plataformas Corporativas",
      admin: "Plataformas Corporativas · Administrador",
    },
    pipeline: {
      prospecto: "Prospecto",
      docs: "Docs",
      aiAnalysis: "Análisis Pando",
      prep: "Prep. Oferta",
      submitted: "Presentada",
      negotiation: "Negociación",
    },
    projectState: {
      active: "Activos",
      completed: "Completados",
      paused: "Pausados",
      blocked: "Bloqueados",
    },
    budgetCat: {
      licenses: "Licencias",
      external: "Rec. Externos",
      internal: "Rec. Internos",
    },
    budgetVsExecuted: "Presupuesto vs Ejecutado",
  },

  tender: {
    title: "US_BID360",
    subtitle: "Pipeline de licitaciones públicas y oportunidades externas",
    filters: "Filtros",
    refreshSources: "Sincronizar fuentes",
    search: "Buscar por título, organismo, CPV…",
    source: "Fuente",
    area: "Área",
    province: "Provincia",
    status: "Estado",
    scoreMin: "Score mínimo",
    deadline: "Plazo de presentación",
    organism: "Organismo",
    value: "Importe",
    publication: "Publicación",
    score: "Score Pando",
    rationale: "Razonamiento Pando",
    viewDetails: "Ver detalle",
    convertToOffer: "Convertir a oferta",
    open: "Abrir pliego",
    runAi: "Ejecutar análisis Pando",
    aiRunning: "Analizando…",
    noResults: "Sin oportunidades",
    noResultsHint: "Ajusta los filtros o ejecuta una sincronización",
    showing: "Mostrando {{n}} de {{total}}",
    cuadroMando: "Cuadro de Mando",
    analytics: "Analítica",
    map: "Mapa",
  },

  offers: {
    title: "Ofertas TIC",
    subtitle: "Cartera de ofertas con CAPEX/OPEX y validación TIC + CFO",
    new: "Nueva oferta",
    state: "Estado",
    validationStatus: "Validación",
    capex: "CAPEX",
    opex: "OPEX",
    total: "Total contrato",
    deadline: "Presentación",
    requestValidation: "Solicitar validación TIC",
    validateTic: "Validar TIC",
    requestCfo: "Pedir aprobación CFO",
    approveCfo: "Aprobar CFO",
    desestimate: "Desestimar",
    states: {
      draft: "Borrador",
      borrador: "Borrador",
      in_review: "En revisión",
      pending_validation: "Esperando TIC",
      pending_cfo: "Esperando CFO",
      pending_cfo_approval: "Esperando CFO",
      approved: "Aprobada",
      approved_with_conditions: "Aprobada con condiciones",
      rejected: "Rechazada",
      desestimada: "Desestimada",
    },
  },

  ofertasComercial: {
    title: "Contratación VSM",
    subtitle: "Pipeline comercial de licitaciones de servicios urbanos",
    new: "Nueva oferta",
    importExcel: "Importar Excel",
    exportExcel: "Exportar Excel",
    expediente: "Expediente",
    cliente: "Cliente",
    objeto: "Objeto del contrato",
    presupuesto: "Presupuesto",
    deadline: "Presentación",
    estado: "Estado licitación",
    aiScore: "Score Pando",
    compliance: "Compliance",
    competitive: "Análisis competitivo",
    estadoLicitacion: {
      estudio: "En estudio",
      no_estudio: "No estudio",
      presentada: "Presentada",
      ganada: "Ganada",
      perdida: "Perdida",
      adjudicada: "Adjudicada",
    },
  },

  compliance: {
    title: "Compliance Check Pando",
    rerun: "Re-ejecutar",
    generating: "Generando…",
    analyzing: "Analizando oferta con Pando… (≈10-20 s)",
    verifications: "Verificaciones",
    blockers: "Bloqueantes",
    alerts: "Alertas",
    recommendations: "Recomendaciones",
    conclusion: "Conclusión",
    generatedBy: "Generado: {{date}} · por {{author}}",
    nivel: {
      ok: "Cumplimiento OK",
      atencion: "Requiere atención",
      bloqueante: "Bloqueante",
    },
    verif: {
      plazos: "Plazos",
      presupuesto: "Presupuesto y rentabilidad",
      encaje_negocio: "Encaje con área de negocio",
      plataforma: "Plataforma de licitación",
      competencia: "Análisis de competencia",
      datos_oferta: "Completitud de la ficha",
    },
  },

  manuals: {
    title: "Manuales",
    subtitle: "Documentación oficial de la plataforma",
    download: "Descargar PDF",
    view: "Ver online",
    platform: "Manual de Plataforma",
    apiIntegration: "Manual de Integración API",
    offers: "Manual de Ofertas",
    tender360: "Manual US_BID360",
  },

  reports: {
    title: "Informes Pando",
    subtitle: "Resúmenes y análisis ejecutivos generados por Pando",
    weekly: "Resumen semanal",
    monthly: "Resumen mensual",
    custom: "Informe personalizado",
    generate: "Generar nuevo",
    runAi: "Ejecutar Pando",
    download: "Descargar",
  },

  projects: {
    title: "Proyectos",
    subtitle: "Proyectos .NET y GIS activos",
    new: "Nuevo proyecto",
    name: "Nombre",
    state: "Estado",
    owner: "Responsable",
    startDate: "Inicio",
    endDate: "Fin",
    progress: "Progreso",
    states: {
      active: "Activo",
      paused: "Pausado",
      completed: "Completado",
      blocked: "Bloqueado",
    },
  },

  backlog: {
    title: "Backlog",
    subtitle: "Historias de usuario y tareas pendientes",
    new: "Nueva historia",
    storyPoints: "SP",
    priority: "Prioridad",
    sprint: "Sprint",
    assignee: "Asignado",
    column: {
      todo: "Por hacer",
      inProgress: "En curso",
      review: "Revisión",
      done: "Hecho",
    },
  },

  admin: {
    title: "Administración",
    subtitle: "Gestión de usuarios, permisos y configuración del sistema",
    users: {
      title: "Usuarios",
      pending: "Pendientes de aprobación",
      active: "Activos",
      approve: "Aprobar",
      reject: "Rechazar",
      changeRole: "Cambiar rol",
      resetPassword: "Resetear contraseña",
    },
    quotas: {
      title: "Cuotas OpenAI-compat",
      monthlyLimit: "Límite mensual (tokens)",
      rpm: "RPM",
      used: "Usado",
      newQuota: "Nueva cuota",
    },
    sync: {
      title: "Sincronización de Entornos",
      downloadDump: "Descargar dump JSON",
      uploadJson: "Subir y aplicar JSON",
      applying: "Aplicando…",
      lastSync: "Última sincronización",
    },
    delegados: {
      title: "Delegados Regionales",
      subtitle: "Alertas de oportunidades filtradas por zona geográfica (vista en /delegado)",
      newDelegado: "Nuevo delegado",
      editDelegado: "Editar delegado",
      reload: "Recargar",
      empty: "Aún no hay delegados configurados. Crea el primero con el botón \"Nuevo delegado\".",
      cols: {
        delegado: "Delegado",
        zone: "Zona",
        aiAreas: "Áreas Pando",
        scoreMin: "Score mín.",
        status: "Estado",
        actions: "Acciones",
      },
      form: {
        emailRequired: "Email y nombre son obligatorios",
        zoneRequired: "Selecciona al menos una provincia o comunidad",
        template: "Plantilla de zona",
        templateHint: "Al elegir una zona, autocompleta provincias y comunidades del listado oficial.",
        templateCustom: "— Custom (editar manualmente) —",
        provincias: "Provincias (CSV)",
        comunidades: "Comunidades autónomas (CSV)",
        aiAreasLabel: "Áreas Pando · Core Valoriza",
        scoreMinLabel: "Score Pando mínimo",
        scoreHint: "Recomendado: 75",
        activeLabel: "Activo (recibe emails)",
        autoCreate: "Al guardar, si el usuario no existe se creará automáticamente con rol",
        autoCreatePwd: "contraseña inicial",
        autoCreateLogin: "y cambio obligatorio al primer login. El delegado podrá entrar directamente en",
        save: "Crear delegado",
        userCreated: "✓ Delegado creado · cuenta de usuario también generada (pwd inicial: Valoriza2026!)",
        updated: "Delegado actualizado",
        configured: "Delegado configurado (usuario ya existía)",
        deleteConfirm: "¿Eliminar la configuración de delegado para {{email}}?",
        deleted: "Configuración eliminada",
      },
    },
  },
  arrive: {
    title: "Checklists ARRIVE",
    subtitle: "Pruebas de la APP de movilidad",
    newChecklist: "Nuevo checklist",
    importExcel: "Importar desde Excel (Pando)",
    exportExcel: "Exportar Excel",
    importResults: "Importar resultados desde Excel",
    city: "Ciudad",
    checklist: "Checklist",
    category: "Categoría",
    subcategory: "Subcategoría",
    item: "Ítem",
    result: "Resultado",
    observations: "Observaciones",
    date: "Fecha",
    responsible: "Responsable",
    completion: "Completado",
    items: "ítems",
    ok: "OK",
    nok: "NOK",
    na: "N/A",
    noResult: "Sin resultado",
    noChecklists: "Sin checklists aún",
    createFirst: "Crea el primer checklist para empezar",
  },
  projectDetail: {
    workItems: "Work Items",
    listView: "Lista",
    kanbanView: "Tablero",
    newItem: "Nuevo ítem",
    markComplete: "Marcar como completado",
    saveChanges: "Guardar cambios",
    sendToDevops: "Enviar a DevOps",
    publishToDevops: "Publicar en DevOps",
    teamNotes: "Notas del equipo",
    addNote: "Añadir una nota (Ctrl+Enter para guardar)…",
    title: "Título",
    status: "Estado",
    priority: "Prioridad",
    type: "Tipo",
    assignedTo: "Asignado a",
    sprint: "Sprint",
    storyPts: "Story Pts",
    estimatedH: "Est. (h)",
    completedH: "Complet. (h)",
    remainingH: "Restantes (h)",
    targetDate: "Fecha objetivo",
    tags: "Tags",
    description: "Descripción",
    information: "Información",
    viewInDevops: "Ver en Azure DevOps",
    noSprint: "Sin sprint",
    created: "Creado",
    modified: "Modificado",
  },
};

export default es;
